import script from "./NameFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./NameFilter.vue?vue&type=script&setup=true&lang=js"

import "./NameFilter.vue?vue&type=style&index=0&id=517e2d8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517e2d8e"]])

export default __exports__